<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span id="Page_1" title="[Pg 1]"></span></p>
<h2 class="nobreak" id="First_Day">First Day.</h2>
</div>
<div class="figcenter3" id="i05">
<img alt="" class="w" id="id-8083061090973934684" src="Images/img0002.jpg"/>
</div>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">A good action is its own</div>
<div class="verse1">reward.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Dickens.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">The will to do well ... is the next</div>
<div class="verse2">thing to having the power.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Mr. Pecksniff.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Forgiveness is a high quality,</div>
<div class="verse2">an exalted virtue.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Martin Chuzzlewit.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">In love of home the love of</div>
<div class="verse3">country has its rise.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Old Curiosity Shop.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Tears never yet wound up a clock or worked</div>
<div class="verse4">a steam-engine.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Sam Weller.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?4a074f25